import { VITE_API_URL } from "@/constants";

interface FetcherType {
  method: "DELETE" | "GET" | "POST";
  body?: string;
  token: string;
  orgId: string;
}

interface TokenInvalidResponse {
  error: string;
  message: string;
}

export async function authedFetch(url: string, opts: FetcherType) {
  const response = await fetch(`${VITE_API_URL}${url}`, {
    method: opts.method,
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${opts.token}`,
      "X-Inventoree-Organization": opts.orgId,
    },
    credentials: "include",
    ...(opts.body && { body: opts.body }),
  });

  return response;
}

/**
 * A fetch of the account's products is already running, the API answers 409
 */
export class FetchRunningError extends Error {}

/**
 * Checks if a response indicates the token is invalid (JWT secret was rotated, etc.)
 * Returns true if the response is a token_invalid error that requires logout
 */
export async function isTokenInvalid(response: Response): Promise<boolean> {
  if (response.status === 401) {
    try {
      const data = (await response.clone().json()) as TokenInvalidResponse;
      return data.error === "token_invalid";
    } catch {
      // If we can't parse as JSON, it's not a token_invalid error
      return false;
    }
  }
  return false;
}
